// whole component should refactor
import React, { useState } from "react";
import {
  Divider,
  Button,
  Grid,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Autocomplete,
  TextField,
  FormLabel,
} from "@mui/material";

export default function AddFC({ fcListOptions, addVendorFc }) {
  const [open, setOpen] = useState(false);
  const [selectedFc, setSelectedFc] = useState({});

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Button
        variant="contained"
        sx={{ ml: 1, fontSize: "13px", background: "#4d6fa5", color: "#fff" }}
        onClick={handleClickOpen}
      >
        Add New FC
      </Button>
      {open && (
        <Dialog
          fullWidth
          maxWidth="lg"
          open={open}
          onClose={handleClose}
          disableEscapeKeyDown={true}
        >
          <DialogTitle>
            <Typography color="primary" variant="h6">
              Add New FC
            </Typography>
          </DialogTitle>
          <Divider />
          <DialogContent>
            <Grid sx={{ background: "#fff" }}>
              {/* <Divider />  */}
              <Grid item xs={12} md={12}>
                <FormLabel
                  required={true}
                  sx={{ width: "220px" }}
                  className="stepperFormLabel"
                >
                  Select FC{" "}
                </FormLabel>
                <Autocomplete
                  sx={{ display: "inline-block", width: "50%" }}
                  fullWidth
                  id="controllable-states-demo"
                  options={fcListOptions}
                  className="input-correction"
                  getOptionLabel={(option) =>
                    `${option?.fcCode} - ${option?.fcName}`
                  }
                  onChange={(event, newValue) => {
                    setSelectedFc(newValue);
                  }}
                  size="small"
                  renderInput={(params) => (
                    <TextField {...params} className="input-correction" />
                  )}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <Divider />
          <DialogActions>
            <Button color="error" variant="outlined" onClick={handleClose}>
              Cancel
            </Button>
            <Button
              variant="outlined"
              //   onClick={handleSubmit(onSubmit)}
              autoFocus
              onClick={() => {
                addVendorFc(selectedFc);
                handleClose();
              }}
              disabled={selectedFc === null || !selectedFc?.fcCode}
            >
              Add
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </div>
  );
}
